import { call, fork, put, select, take } from 'redux-saga/effects'
import { isCustomHeaderAndFooterCustomer } from '../../helpers/utils'
import { fetchFooter } from './actions'
import { FETCH_FOOTER_DATA } from './constants'
import { fetchFooterApi } from './services'

function* footerWorker(language, version) {
  const state = yield select()
  const customer = state.devicebits.customer
  if (!isCustomHeaderAndFooterCustomer(customer)) return
  
  try {
    const response = yield call(fetchFooterApi, language, version)
    if (Object.keys(response).includes('items')) {
      yield put(fetchFooter.success(response))
    }
  } catch (e) {
    yield put(fetchFooter.failure(e))
  }
}

function* footerWatcher() {
  while (true) {
    const { language, version } = yield take(FETCH_FOOTER_DATA['REQUEST'])
    yield call(footerWorker, language, version)
  }
}

export default function* rootSaga() {
  yield fork(footerWatcher)
}



// WEBPACK FOOTER //
// ./src/containers/Footer/sagas.js